import React, { useState, useEffect } from 'react';

const CounterUp = ({ start = 0, end, duration = 2000, title }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    const increment = (end - start) / (duration / 16);

    const updateCounter = () => {
      setCount((prevCount) => {
        if (prevCount < end) {
          return prevCount + increment;
        } else {
          clearInterval(timer);
          return end;
        }
      });
    };

    const timer = setInterval(updateCounter, 16);

    return () => clearInterval(timer);
  }, [end, start, duration]);

  return (
    <div className="text-center py-4">
      <h1 className="text-5xl font-bold text-gray-100 mb-2">
        <span className="text-blue-600">{Math.ceil(count)}+</span>
      </h1>
      <h3 className="mt-1 font-semibold">{title}</h3>
    </div>
  );
};

export default CounterUp;
